import React, { Component } from "react";
import { connect } from "react-redux";
import { Grid, Row, Col } from "react-bootstrap";
import { Card } from "components/Card/Card.jsx";
import SimpleReactValidator from "simple-react-validator";
import Contact from "./../../ThemeComponents/Contact";
import { listActions } from "../../../redux/actions/list-actions";
import { userActions } from "../../../redux/actions/user-actions";


var Modal = require("react-bootstrap-modal");

class UserProfile extends Component {
    constructor(props) {
        super(props);
        this.validator = new SimpleReactValidator();
        var userAdmin = JSON.parse(localStorage.getItem("user"));
        this.state = {
            user: {
                contact: {
                    first_name: "",
                    last_name: "",
                    email: "",
                    type_id: "",
                    phone: "",
                    model_id: userAdmin.result.user.model_id,
                    model: userAdmin.result.user.model
                },
                userHasFetched: false
            },
            submitted: false
        };

        this.handleCustomerSubmit = this.handleCustomerSubmit.bind(this);
        this.handleChangeDropdown = this.handleChangeDropdown.bind(this);
        this.getChildState = this.getChildState.bind(this);
    }

    componentDidMount() {
        this.props.getListCall('country', "", "", "", "", "country", false);
        this.props.getUserProfileCall()
    }

    componentDidUpdate(prevProps) {
        if (this.props.user_profile !== prevProps.user_profile) {
            this.setState({
                user: {
                    contact: {
                        ...this.state.user.contact,
                        ...this.props.user_profile.contact,
                    }
                },
                userHasFetched: true,
            })
        }
    }

    getState = state => {
        if (state.tagTypeAddModal !== undefined) {
            this.setState(prevState => ({
                ...prevState.tagTypeAddModal,
                ...state
            }));
        } else {
            this.setState(prevState => ({
                user: {
                    ...prevState.user,
                    ...state
                }
            }));
        }
    };

    handleCustomerSubmit(e) {
        e.preventDefault();
        if (this.validator.allValid()) {
            this.setState({
                submitted: true
            });
            const { user } = this.state;
            let obj = { ...user };
            this.props.updateUserCall(obj).then(res => {
                this.props.getUserProfileCall();
            });
        } else {
            this.setState({ submitted: false });
            this.validator.showMessages();
            this.forceUpdate();
        }
    }
    handleChangeDropdown(selectedOption, info) {
        if (info.name === "state") {
            console.log("state select menu", selectedOption);
            this.setState({
                customer: {
                    ...this.state.customer,
                    stateId: selectedOption.value
                }
            });
        }
        if (info.name === "country") {
            this.setState(
                {
                    customer: {
                        ...this.state.customer,
                        countryId: selectedOption.value
                    }
                },
                () => {
                    let updatedStates = [];
                    this.props.states.forEach(state => {
                        if (state.countryId === this.state.customer.countryId)
                            updatedStates.push(state);
                    });
                    this.setState({
                        ...this.state.customer,
                        states: updatedStates
                    });
                }
            );
        }
    }
    getChildState(childData) {
        this.setState(
            {
                addressObj: childData
            },
            () => {
                console.log("the child state data", this.state.addressObj);
            }
        );
    }

    render() {
        return (
            <React.Fragment>
                <div className="content">
                    <Grid fluid>
                        <Row>
                            <Col md={12}>
                                <Card
                                    ctTableResponsive
                                    content={
                                        <div>
                                            <Grid fluid>
                                                <Row>
                                                    <div
                                                        className="col-md-8"
                                                        style={{
                                                            margin: "0 auto",
                                                            float: "none"
                                                        }}
                                                    >
                                                        <Col md={12}>
                                                            <div className="flexElem flexResponsive halfCols alignFlexCenter">
                                                                <div className="fieldWithIcon">
                                                                    <h3
                                                                        style={{
                                                                            fontWeight:
                                                                                "500"
                                                                        }}
                                                                    >
                                                                        Profile
                                                                    </h3>
                                                                </div>
                                                            </div>
                                                            <hr />
                                                        </Col>

                                                        <Col md={12}>
                                                            <form
                                                                onSubmit={
                                                                    this
                                                                        .handleCustomerSubmit
                                                                }
                                                            >
                                                                <div className="flexElem addCustomer">
                                                                    {this.state
                                                                        .userHasFetched && (
                                                                            <Contact
                                                                                formTypePro="edit"
                                                                                contactProp={
                                                                                    this
                                                                                        .state
                                                                                        .user
                                                                                }
                                                                                contactObject={
                                                                                    this
                                                                                        .state
                                                                                        .user
                                                                                }
                                                                                htmlElement={
                                                                                    "customer"
                                                                                }
                                                                                shippingAddress={
                                                                                    false
                                                                                }
                                                                                requiredField={{
                                                                                    first_name:
                                                                                        "required",
                                                                                    last_name:
                                                                                        "required",
                                                                                    email: [
                                                                                        "email",
                                                                                        "required"
                                                                                    ]
                                                                                }}
                                                                                getChildState={
                                                                                    this
                                                                                        .getState
                                                                                }
                                                                                returnState={
                                                                                    this
                                                                                        .getState
                                                                                }
                                                                                validatorInstance={
                                                                                    this
                                                                                        .validator
                                                                                }
                                                                            />
                                                                        )}
                                                                </div>

                                                                <div className="col-md-12 text-center mt-xlg">
                                                                    <input
                                                                        type="submit"
                                                                        value="Save Changes"
                                                                        className="customBtn btnBlue"
                                                                    />
                                                                </div>
                                                            </form>
                                                        </Col>
                                                    </div>
                                                </Row>
                                            </Grid>
                                        </div>
                                    }
                                />
                            </Col>
                        </Row>
                    </Grid>
                </div>


            </React.Fragment>
        );
    }
}
const mapDispatchToProps = dispatch => {
    return {
        getListCall: (
            id,
            page,
            filter,
            sort,
            pageSize,
            component_name,
            pagination
        ) => {
            dispatch(
                listActions.getList(
                    id,
                    page,
                    filter,
                    sort,
                    pageSize,
                    component_name,
                    pagination
                )
            );
        },
        getUserItemCall: id => {
            return dispatch(userActions.getUser(id));
        },
        getUserProfileCall: () => {
            return dispatch(userActions.getUserProfile());
        },
        storeTagTypeCall: listData => {
            return dispatch(listActions.storeList(listData));
        },
        refreshRegionsListCall: id => {
            return dispatch(listActions.getListItem(id));
        },
        updateUserCall: (data, model = {}) => {
            return dispatch(userActions.editUserProfile(data, model));
        }
    };
};

function mapStateToProps(state) {
    const { country, address } = state.listReducer;
    const { user_profile } = state.userReducer;
    return {
        countries: country,
        address,
        user_profile
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(UserProfile);



// WEBPACK FOOTER //
// ./src/components/Admin/Users/UserProfile.jsx